export default __webpack_public_path__ + "static/char-v-50-2c5ba25c982f5453bcadafacb1ba12af.png";